import { createGetApi, createPostApi } from 'friday-async';

interface FormField {
  key: string;
  label: string;
  type: 'text' | 'phone' | 'select' | 'upload';
  required: boolean;
  placeholder?: string;
  options?: string[];
  dictCode?: string;
  sort?: number;
}

interface BenefitConfig {
  name: string;
  description: string;
  image: string;
}

interface FTMSConfig {
  mediaId: string;
  mediaLeadType: string;
  channelKeyId: number;
  activity: string;
}

class Apis {
  public list = createGetApi<void>({
    url: '/activity/list',
  });

  public create = createPostApi<{
    name: string;
    code?: string;
    description?: string;
    headImage?: string;
    benefit?: BenefitConfig;
    protocolUploadEnabled?: boolean;
    formFields?: FormField[];
    status?: string;
    smsEnabled?: boolean;
    smsTemplateId?: string;
    ftmsConfig?: FTMSConfig;
  }>({
    url: '/activity/create',
  });

  public update = createPostApi<{
    _id: string;
    name: string;
    code?: string;
    description?: string;
    headImage?: string;
    benefit?: BenefitConfig;
    protocolUploadEnabled?: boolean;
    formFields?: FormField[];
    status?: string;
    smsEnabled?: boolean;
    smsTemplateId?: string;
    ftmsConfig?: FTMSConfig;
  }>({
    url: '/activity/update',
  });

  public toggleStatus = createPostApi<{_id: string; status: string}>({
    url: '/activity/toggleStatus',
  });

  public remove = createPostApi<{_id: string}>({
    url: '/activity/remove',
  });

  public getByCode = createGetApi<{ code: string }>({
    url: '/activity/getByCode',
  });

  public leadApproval = new LeadApprovalApis();
}

class LeadApprovalApis {
  public approve = createPostApi<{
    _id: string;
    action: 'approved' | 'rejected';
    reason?: string;
  }>({
    url: '/lead-approval/approve',
  });

  public history = createGetApi<{ _id: string }>({
    url: '/lead-approval/history',
  });

  public batchResetToIssued = createPostApi<{ ids: string[] }>({
    url: '/lead-approval/batchResetToIssued',
  });
}

export default Apis;
export { LeadApprovalApis };
